module.exports = __webpack_public_path__ + "img/logo.40ef6d1b.png";